export const MediaRailSkeleton = () => (
  <section className="w-full overflow-hidden bg-(--color-surface-default) pb-6">
    <div className="mb-5 h-6 w-48 animate-pulse rounded bg-(--color-surface-neutral) px-(--layout-inline-padding)" />

    <div className="relative py-5">
      <div className="flex items-start gap-3 pl-(--layout-inline-padding)">
        {Array.from({ length: 5 }).map((_, i) => (
          <div
            key={i}
            className="h-[var(--poster-height)] w-[var(--poster-width)] shrink-0 animate-pulse rounded-md bg-(--color-surface-neutral)"
            style={
              i === 0
                ? {
                    width: 'var(--expanded-width)',
                    height: 'var(--expanded-height)',
                  }
                : undefined
            }
          />
        ))}
      </div>
    </div>

    <div className="mx-(--layout-inline-padding) min-h-35 border-t border-(--color-border-neutral-softer-3) pt-6">
      <div className="mb-5 h-6 w-64 animate-pulse rounded bg-(--color-surface-neutral)" />
      <div className="h-4 w-full max-w-180 animate-pulse rounded bg-(--color-surface-neutral)" />
    </div>
  </section>
);
